// import React, { useState } from 'react';
// import axios from 'axios';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import { formatReadableAmount } from "../../Common/FormatFunctions/FormatAmount"
// import Swal from 'sweetalert2';

// const API_URL = process.env.REACT_APP_API;

// const CreateB2ClFile = ({ fromDate, toDate, companyCode, yearCode }) => {
//     const [data, setData] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState('');
//     const [isDataFetched, setIsDataFetched] = useState(false);

//     const fetchCreateB2ClFile = async () => {
//         try {
//             setLoading(true);
//             setError('');
//             const response = await axios.get(`${API_URL}/CreateB2ClFileData-summary`, {
//                 params: {
//                     from_date: fromDate,
//                     to_date: toDate,
//                     Company_Code: companyCode,
//                     Year_Code: yearCode,
//                 },
//             });
//             if (response.data.length === 0) {
//                 Swal.fire({
//                     icon: 'error',
//                     title: 'Data Not Found.!',
//                     text: 'No CreateB2ClFile data found for the selected date range.',
//                 });
//                 return;
//             }
//             setData(response.data);
//             setIsDataFetched(true);
//             openReportInNewTab(response.data); 
//         } catch (err) {
//             setError('Failed to fetch data');
//         } finally {
//             setLoading(false);
//         }
//     };

//     const openReportInNewTab = (data) => {
//         const newWindow = window.open('', '_blank');
//         if (!newWindow) return;

//         const columns = [
//             'Invoice Number',
//             'Invoice date',
//             'Invoice Value',
//             'Place Of Supply',
//             'Rate',
//             'Taxable Value',
//             'Cess Amount',
//             'E-Commerce GSTIN'
//         ];

//         newWindow.document.write(`
//             <html>
//                 <head>
//                     <title>Create B2Cl Report</title>
//                     <script src="https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js"></script>
//                     <style>
//                         body { font-family: Arial, sans-serif; padding: 20px; text-align: center; }
//                         h2 { text-align: center; margin-top: 0; }
//                         table { width: 80%; margin: 20px auto; border-collapse: collapse; }
//                         th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
//                         th { background-color: #f4f4f4; }
//                         .export-btn { 
//                             padding: 10px 20px; 
//                             font-size: 16px; 
//                             background-color: green; 
//                             color: white; 
//                             border: none; 
//                             cursor: pointer; 
//                             margin-top: 20px;
//                         }
//                     </style>
//                 </head>
//                 <body>
//                     <h2>Create B2Cl File Report</h2>
//                     <button class="export-btn" onclick="window.exportToXlsx()">Export to Excel</button>
//                     <table>
//                         <thead>
//                             <tr>
//                                 ${columns.map((column) => `<th>${column}</th>`).join('')}
//                             </tr>
//                         </thead>
//                         <tbody>
//                             ${data.map(row => {
//                                 return `
//                                     <tr>
//                                      ${columns.map(column => {
//                                      if (['Taxable Value', 'Invoice Value'].includes(column)) {
//                                         return `<td style="text-align: right;">${formatReadableAmount(row[column] || 0)}</td>`;
//                                        } else {
//                                      return `<td>${row[column] || ''}</td>`;
//                                       }
//                                       }).join('')}
//                                    </tr>
//                                 `;
//                             }).join('')}
//                         </tbody>
//                     </table>
//                     <script>
//                         window.exportToXlsx = function() {
//                             const data = ${JSON.stringify(data)};
//                             const columnOrder = ['Invoice Number','Invoice date','Invoice Value','Place Of Supply','Rate','Taxable Value','Cess Amount','E-Commerce GSTIN'];
//                             const ws = XLSX.utils.json_to_sheet(data, { header: columnOrder, skipHeader: false });
//                             const wb = XLSX.utils.book_new();
//                             XLSX.utils.book_append_sheet(wb, ws, 'B2Cl Report');
//                             XLSX.writeFile(wb, 'B2ClFile.xlsx');
//                         };
//                     </script>
//                 </body>
//             </html>
//         `);

//         newWindow.document.close();
//     };

//     return (
//         <div className="d-flex flex-column align-items-center" style={{ marginTop: '5px' }}>
//             <button
//                 className="btn btn-primary"
//                 onClick={fetchCreateB2ClFile}
//                 disabled={loading}
//                 style={{
//                     width: '20%',  
//                     height: '60px',  
//                 }}
//             >
//                 {loading ? 'Loading...' : 'Create B2Cl File'}
//             </button>

//             {error && <div className="alert alert-danger">{error}</div>}
//         </div>
//     );
// };

// export default CreateB2ClFile;


import React, { useState } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { formatReadableAmount } from "../../Common/FormatFunctions/FormatAmount"
import Swal from 'sweetalert2';

const API_URL = process.env.REACT_APP_API;

const CreateB2ClFile = ({ fromDate, toDate, companyCode, yearCode }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [portalLoading, setPortalLoading] = useState(false);
    const [error, setError] = useState('');

    const fetchCreateB2ClFile = async () => {
        try {
            setLoading(true);
            setError('');
            const response = await axios.get(`${API_URL}/CreateB2ClFileData-summary`, {
                params: {
                    from_date: fromDate,
                    to_date: toDate,
                    Company_Code: companyCode,
                    Year_Code: yearCode,
                },
            });
            if (response.data.length === 0) {
                Swal.fire({
                    icon: 'error',
                    title: 'Data Not Found.!',
                    text: 'No CreateB2ClFile data found for the selected date range.',
                });
                return;
            }
            setData(response.data);
            openReportInNewTab(response.data);
        } catch (err) {
            setError('Failed to fetch data');
        } finally {
            setLoading(false);
        }
    };

    // ── Called from the new-window button ──────────────────────────────────────
    const exportToPortalExcel = async (newWindow) => {
        try {
            // Show overlay loader inside the new window
            const loader = newWindow.document.createElement("div");
            loader.id = "reportLoader";
            loader.innerHTML = `
                <style>
                .loader {
                    animation: rotate 1s infinite;
                    height: 50px; width: 50px; display: inline-block;
                }
                .loader:before, .loader:after {
                    border-radius: 50%; content: ''; display: block;
                    height: 20px; width: 20px;
                }
                .loader:before {
                    animation: ball1 1s infinite;
                    background-color: #cb2025;
                    box-shadow: 30px 0 0 #f8b334;
                    margin-bottom: 10px;
                }
                .loader:after {
                    animation: ball2 1s infinite;
                    background-color: #00a096;
                    box-shadow: 30px 0 0 #97bf0d;
                }
                @keyframes rotate {
                    0%   { transform: rotate(0deg) scale(0.8); }
                    50%  { transform: rotate(360deg) scale(1.2); }
                    100% { transform: rotate(720deg) scale(0.8); }
                }
                @keyframes ball1 {
                    0%   { box-shadow: 30px 0 0 #f8b334; }
                    50%  { box-shadow: 0 0 0 #f8b334; margin-bottom: 0; transform: translate(15px,15px); }
                    100% { box-shadow: 30px 0 0 #f8b334; margin-bottom: 10px; }
                }
                @keyframes ball2 {
                    0%   { box-shadow: 30px 0 0 #97bf0d; }
                    50%  { box-shadow: 0 0 0 #97bf0d; margin-top: -20px; transform: translate(15px,15px); }
                    100% { box-shadow: 30px 0 0 #97bf0d; margin-top: 0; }
                }
                </style>
                <div style="
                    position:fixed; top:0; left:0;
                    width:100%; height:100%;
                    background:rgba(0,0,0,0.45);
                    display:flex; justify-content:center;
                    align-items:center; z-index:99999;
                    flex-direction:column;
                ">
                    <div class="loader"></div>
                    <div style="margin-top:18px; color:white; font-size:20px;
                                font-weight:bold; font-family:Arial;">
                        Downloading Excel...
                    </div>
                </div>
            `;
            newWindow.document.body.appendChild(loader);

            const response = await axios.get(
                `${API_URL}/CreateGSTR1Combined-summary`,
                {
                    params: {
                        from_date: fromDate,
                        to_date: toDate,
                        Company_Code: companyCode,
                        Year_Code: yearCode,
                    },
                    responseType: "blob",
                }
            );

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = newWindow.document.createElement("a");
            link.href = url;
            link.download = "GSTR1_Combined.xlsx";
            newWindow.document.body.appendChild(link);
            link.click();
            link.remove();

        } catch (err) {
            newWindow.alert("Failed to download Portal Excel. Please try again.");
        } finally {
            const loader = newWindow.document.getElementById("reportLoader");
            if (loader) loader.remove();
        }
    };
    // ───────────────────────────────────────────────────────────────────────────

    const openReportInNewTab = (data) => {
        const newWindow = window.open('', '_blank');
        if (!newWindow) return;

        const columns = [
            'Invoice Number',
            'Invoice date',
            'Invoice Value',
            'Place Of Supply',
            'Rate',
            'Taxable Value',
            'Cess Amount',
            'E-Commerce GSTIN'
        ];

        newWindow.document.write(`
            <html>
                <head>
                    <title>Create B2Cl Report</title>
                    <script src="https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js"></script>
                    <style>
                        body { font-family: Arial, sans-serif; padding: 20px; text-align: center; }
                        h2 { text-align: center; margin-top: 0; }
                        table { width: 80%; margin: 20px auto; border-collapse: collapse; }
                        th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
                        th { background-color: #f4f4f4; }
                        .export-btn {
                            padding: 10px 20px;
                            font-size: 16px;
                            background-color: green;
                            color: white;
                            border: none;
                            cursor: pointer;
                            margin-top: 20px;
                            margin-right: 10px;
                        }
                        .portal-btn {
                            padding: 10px 20px;
                            font-size: 16px;
                            background-color: #1565c0;
                            color: white;
                            border: none;
                            cursor: pointer;
                            margin-top: 20px;
                        }
                    </style>
                </head>
                <body>
                    <h2>Create B2Cl File Report</h2>

                    <button class="export-btn" onclick="window.exportToXlsx()">
                        Export to Excel
                    </button>

                    <button class="portal-btn" onclick="window.exportToPortalExcel()">
                        Export to Portal Excel
                    </button>

                    <table>
                        <thead>
                            <tr>
                                ${columns.map((col) => `<th>${col}</th>`).join('')}
                            </tr>
                        </thead>
                        <tbody>
                            ${data.map(row => `
                                <tr>
                                    ${columns.map(col => {
                                        if (['Taxable Value', 'Invoice Value'].includes(col)) {
                                            return `<td style="text-align:right;">${formatReadableAmount(row[col] || 0)}</td>`;
                                        }
                                        return `<td>${row[col] || ''}</td>`;
                                    }).join('')}
                                </tr>
                            `).join('')}
                        </tbody>
                    </table>

                    <script>
                        window.exportToXlsx = function() {
                            const data = ${JSON.stringify(data)};
                            const columnOrder = [
                                'Invoice Number','Invoice date','Invoice Value',
                                'Place Of Supply','Rate','Taxable Value',
                                'Cess Amount','E-Commerce GSTIN'
                            ];
                            const ws = XLSX.utils.json_to_sheet(data, { header: columnOrder, skipHeader: false });
                            const wb = XLSX.utils.book_new();
                            XLSX.utils.book_append_sheet(wb, ws, 'B2Cl Report');
                            XLSX.writeFile(wb, 'B2ClFile.xlsx');
                        };
                    </script>
                </body>
            </html>
        `);

        // Attach the portal export function AFTER document.write
        newWindow.exportToPortalExcel = () => exportToPortalExcel(newWindow);

        newWindow.document.close();
    };

    return (
        <div className="d-flex flex-column align-items-center" style={{ marginTop: '5px' }}>
            <button
                className="btn btn-primary"
                onClick={fetchCreateB2ClFile}
                disabled={loading}
                style={{ width: '20%', height: '60px' }}
            >
                {loading ? 'Loading...' : 'Create B2Cl File'}
            </button>

            {error && <div className="alert alert-danger">{error}</div>}
        </div>
    );
};

export default CreateB2ClFile;
